/**
 * Resolves a multilingual Record<fieldLang, string> for display.
 * Fallback order: preferred → remaining fallbackLocales → first non-empty key.
 * Never throws; returns `fallback` when empty.
 */
export function resolveLocaleField(
  field: Record<string, string> | null | undefined,
  preferredLocale: string,
  fallbackLocales: string[] = [],
  fallback = ''
): string {
  if (!field) return fallback

  const preferred = field[preferredLocale]
  if (preferred) return preferred

  for (const locale of fallbackLocales) {
    if (locale === preferredLocale) continue
    const value = field[locale]
    if (value) return value
  }

  const first = Object.values(field).find(Boolean)
  return first ?? fallback
}

/** Normalize website-settings language codes (`kz` → `kk`), preserve order. */
export function mapWebSiteLanguageCodes(
  languages?: { value?: string }[] | null
): string[] {
  if (!languages?.length) return []

  const codes: string[] = []
  for (const lang of languages) {
    if (!lang?.value) continue
    const code = lang.value === 'kz' ? 'kk' : lang.value
    if (!codes.includes(code)) codes.push(code)
  }
  return codes
}
